"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _reactErrorBoundary = require("react-error-boundary");
var _cicUtils = _interopRequireDefault(require("@eon-funke/cic-utils"));
var _ErrorFallBackComponent = _interopRequireDefault(require("./account/components/ErrorFallBackComponent/ErrorFallBackComponent"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != (0, _typeof2.default)(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var generateRoutes = function generateRoutes(components) {
  var routes = [];
  Object.keys(components).forEach(function (componentName) {
    var route = {
      routeName: componentName,
      load: function load(container, callback) {
        return components[componentName]().then(function (component) {
          var cscnComponent = (0, _reactErrorBoundary.withErrorBoundary)(component.default, {
            FallbackComponent: _ErrorFallBackComponent.default,
            onError: function onError(error) {
              _cicUtils.default.handleException(error);
            }
          });
          container.register(cscnComponent).as(componentName);
          callback();
          return true;
        }).catch(function (error) {
          // eslint-disable-next-line
          console.error("Could not load component:\n".concat(error));
          return false;
        });
      }
    };
    routes.push(route);
  });
  return routes;
};
var _default = exports.default = generateRoutes({
  PasswordForgottenPageConfirmation: function PasswordForgottenPageConfirmation() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('./account/pages/PasswordForgottenPageConfirmation/PasswordForgottenPageConfirmation'));
    });
  },
  PasswordForgottenPage: function PasswordForgottenPage() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('./account/pages/PasswordForgottenPage/PasswordForgottenPage'));
    });
  },
  ChangeEmailConfirmation: function ChangeEmailConfirmation() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('./account/pages/ChangeEmailConfirmation/ChangeEmailConfirmation'));
    });
  },
  RegisterConfirmation: function RegisterConfirmation() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('./account/pages/RegisterConfirmation/RegisterConfirmation'));
    });
  },
  LogoutTimer: function LogoutTimer() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('./account/components/LogoutTimer/LogoutTimer'));
    });
  }
});
;